import React, { useEffect } from "react";
import { useCookies } from "react-cookie";
import { useNavigate } from "react-router-dom";
import { ROUTES_PATH } from "shared/constants/routesPath";
import RegistrationContent from "widgets/RegistrationContent";

const Registration: React.FC = () => {
  const navigate = useNavigate();
  const [cookies] = useCookies(["auth_key", "user_id"]);

  useEffect(() => {
    if (cookies.auth_key) navigate(ROUTES_PATH.ACCOUNT);
  }, []);

  return (
    <main>
      <RegistrationContent />
    </main>
  );
};

export default Registration;
